import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import AdminPanel from "./pages/AdminPanel";
import { ThemeProvider } from "./contexts/ThemeContext";

function App() {
  // Set title immediately when App loads
  useEffect(() => {
    document.title = 'Crystal Dental Studio - Професійна стоматологія преміум-класу';
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
